<div style="max-width: 400px">
  <mat-tab-group
    animationDuration="0ms"
    (selectedIndexChange)="setSegmentsBasedOnIndex($event)"
  >
    <mat-tab *ngFor="let sub of subtitles" [label]="sub">
      <div class="container">
        <div class="segment" *ngIf="activeSegmentNumberOne">
          <div class="row">
            <span
              >{{
                timeFormatFunction(
                  activeSegmentNumberOne.StartTimeMS - mediaStartTimeStampMs
                )
              }}
              -
              {{
                timeFormatFunction(
                  activeSegmentNumberOne.EndTimeMS - mediaStartTimeStampMs
                )
              }}</span
            >
          </div>
          <div class="row">
            <textarea
              #activeSegmentNumberOneTextarea
              [dir]="activeSegmentNumberOne.isTextRTL ? 'rtl' : 'ltr'"
              [value]="activeSegmentNumberOne.Text"
              (input)="adjustHeight(activeSegmentNumberOneTextarea)"
              (change)="
                updateSegmentValue(activeSegmentNumberOne, $any($event.target).value)
              "
            ></textarea>
          </div>
        </div>
        <div class="segment" *ngIf="activeSegmentNumberTwo">
          <div class="row">
            <span
              >{{
                timeFormatFunction(
                  activeSegmentNumberTwo.StartTimeMS - mediaStartTimeStampMs
                )
              }}
              -
              {{
                timeFormatFunction(
                  activeSegmentNumberTwo.EndTimeMS - mediaStartTimeStampMs
                )
              }}</span
            >
          </div>
          <div class="row">
            <textarea
              #activeSegmentNumberTwoTextarea
              [dir]="activeSegmentNumberTwo.isTextRTL ? 'rtl' : 'ltr'"
              [value]="activeSegmentNumberTwo.Text"
              (input)="adjustHeight(activeSegmentNumberTwoTextarea)"
              (change)="
                updateSegmentValue(activeSegmentNumberTwo, $any($event.target).value)
              "
            ></textarea>
          </div>
        </div>
        <div class="pagination" [hidden]="length == 0">
          <mat-paginator
            #paginator
            (page)="handlePageEvent($event)"
            [length]="length"
            [pageSize]="pageSize"
            [showFirstLastButtons]="false"
            [hidePageSize]="true"
            [pageIndex]="pageIndex"
            aria-label="Select page"
          >
          </mat-paginator>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
